export const recoveryDataKey = 'recover_data';
export const b2G1_recover_key = 'sku_ids';
